import { useMutation, useQuery, useQueryClient, type QueryClient } from "@tanstack/react-query";
import { getBalance, getHistory, processPayment, topUp } from "@/features/wallet/api/walletApi";
import type { WalletProcessPaymentPayload, WalletTopUpPayload } from "@/features/wallet/types";

export const walletKeys = {
  balance: ["wallet", "balance"] as const,
  history: ["wallet", "history"] as const,
};

/**
 * Rifreskon cache-in e wallet-it pa prekur state lokale optimiste.
 */
export const invalidateWalletQueries = (queryClient: QueryClient): void => {
  void queryClient.invalidateQueries({ queryKey: walletKeys.balance });
  void queryClient.invalidateQueries({ queryKey: walletKeys.history });
};

/**
 * Merr balancen aktuale te wallet-it.
 */
export const useWalletBalance = (options?: { enabled?: boolean }) =>
  useQuery({
    queryKey: walletKeys.balance,
    queryFn: getBalance,
    enabled: options?.enabled ?? true,
  });

/**
 * Merr historikun e transaksioneve.
 */
export const useWalletHistory = () =>
  useQuery({
    queryKey: walletKeys.history,
    queryFn: getHistory,
  });

/**
 * Kryen top-up dhe pastaj e rilexon balancen nga backend-i.
 */
export const useWalletTopUp = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WalletTopUpPayload) => topUp(payload),
    onSuccess: () => {
      invalidateWalletQueries(queryClient);
    },
  });
};

/**
 * Kryen nje debit dhe rifreskon state-in financiar nga DB.
 */
export const useWalletProcessPayment = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (payload: WalletProcessPaymentPayload) => processPayment(payload),
    onSuccess: () => {
      invalidateWalletQueries(queryClient);
    },
  });
};
